import React from 'react';
import styles from './CollectionDropDown.module.scss';
import './customStyle.css';
import { LessonContentFragment } from '@api/graphql-codegen'
import NewCoverCard from '../NewCoverCard/NewCoverCard';
import SkeletonCoverCard from '@src/components/SkeletonCoverCard/SkeletonCoverCard';

type Props = {
  id: string;
  sllLessons: any;
  country?: string;
  loading: boolean;
  isOpen: boolean;
  index: number;
  activeIndex?: number;
  isSubHeading?: boolean;
  subHeading?: string;
  subHeadingHighlight?: string;
  onClose?: () => void;
  handleOpenLesson: (e: React.MouseEvent<HTMLDivElement>, content: LessonContentFragment) => void;
  isAUuser: boolean;
};

function CollectionDropDown(props: Props) {
  const {
    sllLessons,
    country="",
    loading,
    handleOpenLesson,
    isSubHeading,
    subHeading,
    subHeadingHighlight,
    isAUuser,
  } = props;

  const handleClick = (e: any) => {
    e.preventDefault();
    e.stopPropagation();
  }

  const SubHeadingView = () => {
    if (!isSubHeading) return null;
  
    const highlights = JSON.parse(subHeadingHighlight || '[]');
  
    if (highlights.length === 0) return null;
  
    const renderHighlights = () => {
      switch (highlights.length) {
        case 1:
          return <span className={styles.highLight}>{highlights[0]}</span>;
  
        case 2:
          return (
            <>
              <span className={styles.highLight}>{highlights[0]}</span>
              <span> and </span>
              <span className={styles.highLight}>{highlights[1]}</span>
            </>
          );
  
        default:
          return (
            <>
              {highlights.slice(0, -1).map((item, index) => (
                <React.Fragment key={index}>
                  <span className={styles.highLight}>{item}, </span>
                </React.Fragment>
              ))}
              <span> and </span>
              <span className={styles.highLight}>{highlights[highlights.length - 1]}</span>
            </>
          );
      }
    };
  
    return (
      <div className={styles.subHeading}>
        <span style={{ display: 'inline' }}>{subHeading} </span>
        {renderHighlights()}
      </div>
    );
  };  

  return (
      <div className={styles.subView} onClick={handleClick}>
        <div>
          <div className={styles.content}>
            {<div className={styles.unitView}>
              <SubHeadingView /> 
              <div className={styles.unitGroupTitle}></div>
              {loading ? 
              <div className={styles.skeletonLoadingView}>
                <div className={styles.skeletonView} >
                  <SkeletonCoverCard isDark/>
                  <SkeletonCoverCard isDark/>
                  <SkeletonCoverCard isDark/>
                  <SkeletonCoverCard isDark/>
                </div>
              </div> : <div className={styles.unitsDiv}>
              {sllLessons.length > 0 ? 
                (sllLessons?.map((unit, index) => {
                  return (
                    <NewCoverCard
                      key={index}
                      content={unit}
                      country={country}
                      handleOpenContent={handleOpenLesson}
                      isAUuser={isAUuser}
                    />
                  )
                })) : 
                <div className={styles.noContent}>There is no Lesson here.</div>
              }
            </div>}
            </div>}
          </div>
        </div>
      </div>
  );
}

export default CollectionDropDown;
